import { createStore, combineReducers, applyMiddleware } from "redux";
import dailyPulse from "./dailyPulseReducer";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./dailyPulseSagas";
// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

export function createReduxStore() {
  const reducers = combineReducers({
    dailyPulse
  });
  const composeEnhancers = composeWithDevTools({ name: "dailyPulse" });
  const middleware = composeEnhancers(applyMiddleware(sagaMiddleware));
  let store = createStore(reducers, middleware);
  sagaMiddleware.run(rootSaga);
  return store;
}
